import React from "react";
import styled from "@emotion/styled";
import googleIcon from "@src/assets/images/google.svg";
import theme from "@src/styles/base";

const StyledDiv = styled.div`
  display: flex;
  padding: 12px 4rem;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: ${theme.colors.contentPrimary};
  font-weight: 700;
  border-radius: 30px;
  border: 2px solid ${theme.colors.bordersDecorative};
  background: ${theme.colors.backgroundPrimary};
  text-decoration: none;
  cursor: pointer;
  width: 100%;
`;

interface OidcProviderButtonProps {
  provider: string;
}

const getProviderName = (provider: string): string | null => {
  switch (provider) {
    case "google":
      return "Google";
    case "local-oidc-provider":
      return "Local OIDC Provider";
    default:
      return null;
  }
};

const iconsForProvider: Record<string, string> = {
  google: googleIcon,
};

export const OidcProviderButton: React.FC<OidcProviderButtonProps> = ({ provider }) => {
  const providerName = getProviderName(provider);
  const providerIcon = iconsForProvider[provider];

  if (!providerName) {
    return null;
  }

  return (
    <StyledDiv>
      {providerIcon && <img src={providerIcon} alt={providerName} width={24} height={24} />}
      <span>Continue with {providerName}</span>
    </StyledDiv>
  );
};
